import { ReactNode } from 'react'
import { H2, H3 } from '@/common/ui'
import { AccountType } from '@/common/types'
import { KycRequirements } from '@/kyc/KycRequirements'

type Props = {
    title: string
    description: ReactNode
    accountType: AccountType
    frankieOneOnboarding: boolean
    requirementTitle?: string
    requirementSubtitle?: string
    alert?: ReactNode
    headingLevel?: 'h2' | 'h3'
    centered?: boolean
}

export function KycInitiationView({
    title,
    description,
    accountType,
    frankieOneOnboarding,
    requirementTitle,
    requirementSubtitle,
    alert,
    headingLevel = 'h2',
    centered = false,
}: Props) {
    return (
        <div className="w-full flex flex-col justify-start items-start gap-4">
            <div className="self-stretch inline-flex flex-col justify-start items-start gap-4">
                {headingLevel === 'h3' ? (
                    <H3 className={centered ? 'text-start md:text-center mb-4' : 'justify-start mb-0'}>{title}</H3>
                ) : (
                    <H2 className="justify-start mb-0">{title}</H2>
                )}
            </div>
            <div
                className={
                    centered
                        ? 'self-stretch text-start text-balance mb-2'
                        : 'self-stretch justify-start text-sm font-normal leading-tight mb-2'
                }
            >
                {description}
            </div>
            <KycRequirements
                frankieOneOnboarding={frankieOneOnboarding}
                accountType={accountType}
                title={requirementTitle}
                subtitle={requirementSubtitle}
                textClassName={centered ? undefined : 'text-sm'}
            />
            {alert}
        </div>
    )
}
